export default __webpack_public_path__ + "static/media/cer6.36cbf834.png";